<template>
  <div>
    <v-card-title>
      Devamsızlık
      <v-spacer></v-spacer>
      <span>(Toplam: {{ rows.length }})</span>
    </v-card-title>
    <v-simple-table v-if="rows.length > 0" class="table-bordered" dense>
      <template v-slot:default>
        <thead style="background-color:#e4e4e4;" class="font-weight-boldest">
        <tr>
          <th class="text-left">Ders</th>
          <th v-for="status in statusHeaders" :key="status" class="text-center">
            {{ status }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="course in tableData" :key="course.courseName">
          <td>{{ course.courseName }}</td>
          <td v-for="status in course.statuses" :key="status.name" class="text-center">
            {{ status.count }}
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service.js'

export default {
  props: ['filters'],
  data() {
    return {
      loading: false,
      rows: [],
      statusHeaders: []
    }
  },
  computed: {
    tableData() {
      if (!this.rows || this.rows.length === 0) return []

      // Group by course and count statuses
      const grouped = {}

      this.rows.forEach(row => {
        const courseName = row.CourseName || row.courseName
        const status = row.Status || row.status
        const statuses = row.Statuses || row.statuses

        if (!grouped[courseName]) {
          grouped[courseName] = {
            courseName: courseName,
            statusCounts: {}
          }
          // Initialize all statuses with 0
          if (statuses && Array.isArray(statuses)) {
            statuses.forEach(statusName => {
              grouped[courseName].statusCounts[statusName] = 0
            })
          }
        }
        // Increment the count for this status
        if (status) {
          grouped[courseName].statusCounts[status] =
              (grouped[courseName].statusCounts[status] || 0) + 1
        }
      })

      // Convert to array format for table
      return Object.values(grouped).map(course => ({
        courseName: course.courseName,
        statuses: this.statusHeaders.map(statusName => ({
          name: statusName,
          count: course.statusCounts[statusName] || 0
        }))
      }))
    }
  },
  watch: {
    rows: {
      handler(newRows) {
        if (newRows && newRows.length > 0) {
          // Build status headers from first row's statuses (try both PascalCase and camelCase)
          this.statusHeaders = newRows[0].Statuses || newRows[0].statuses || []
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getDataFromApi()
  },
  methods: {
    getDataFromApi() {
      this.loading = true
      ApiService.setHeader()
      ApiService.post('api/Student/attendance-report-table', this.filters)
          .then(({data}) => {
            this.rows = data
            this.loading = false
          })
          .catch(({response}) => {
            ApiService.showError(response)
            this.loading = false
          })
    },
  }
}
</script>

